// extracted by mini-css-extract-plugin
export default {"container":"bsLXZX","status":"soC1ud"};